module.exports = __webpack_public_path__ + "static/media/terms-blue-grid.f92b0f57.svg";